import { ScopeConfiguration, ScopeVersion } from '@app/core/model/scope-version'
import { createAction, props } from '@ngrx/store'

import { ComponentModifier } from '@app/features/company-management/models/component-modifier.model'
import { InvalidModifiersPayload } from '../../model/scope-configuration/invalid-modifiers-payload.model'
import { KeyValue } from '@app/core/types/key-value.type'

export enum ScopeConfigurationActionTypes {
  SUBMIT_FORM = '[Scope Configuration] Submit Form',
  SHOW_INVALID_MODIFIERS_MODAL = '[Scope Configuration] Show invalid modifiers modal',

  UPDATE_CONFIGURATION = '[Scope Configuration] Update Configuration',

  SAVE_CONFIGURATION = '[Scope Configuration] Save Configuration',
  SAVE_CONFIGURATION_SUCCESS = '[Scope Configuration] Save Configuration Success',
  SAVE_CONFIGURATION_FAIL = '[Scope Configuration] Save Configuration Fail',

  SUBMIT_CONFIGURATION = '[Scope Configuration] Submit Configuration',
  SUBMIT_CONFIGURATION_FAIL = '[Scope Configuration] Submit Configuration Fail',
  SUBMIT_CONFIGURATION_SUCCESS = '[Scope Configuration] Submit Configuration Success',

  GET_MODIFIERS = '[Scope Configuration] Get Modifiers',
  GET_MODIFIERS_FAIL = '[Scope Configuration] Get Modifiers Fail',
  GET_MODIFIERS_SUCCESS = '[Scope Configuration] Get Modifiers Success',
}

const submitForm = createAction(
  ScopeConfigurationActionTypes.SUBMIT_FORM,
  props<{ scenarioId?: number; configuration: ScopeConfiguration }>()
)
const showInvalidModifiersModal = createAction(
  ScopeConfigurationActionTypes.SHOW_INVALID_MODIFIERS_MODAL,
  props<InvalidModifiersPayload>()
)

const updateConfiguration = createAction(
  ScopeConfigurationActionTypes.UPDATE_CONFIGURATION,
  props<{ configuration: ScopeConfiguration }>()
)

const saveConfiguration = createAction(
  ScopeConfigurationActionTypes.SAVE_CONFIGURATION,
  props<{ scopeId: number; configuration: ScopeConfiguration }>()
)
const saveConfigurationSuccess = createAction(
  ScopeConfigurationActionTypes.SAVE_CONFIGURATION_SUCCESS,
  props<{ configuration: ScopeConfiguration }>()
)
const saveConfigurationFail = createAction(
  ScopeConfigurationActionTypes.SAVE_CONFIGURATION_FAIL,
  props<{ error: any }>()
)

const submitConfiguration = createAction(
  ScopeConfigurationActionTypes.SUBMIT_CONFIGURATION,
  props<{ modifierResults?: KeyValue }>()
)
const submitConfigurationSuccess = createAction(
  ScopeConfigurationActionTypes.SUBMIT_CONFIGURATION_SUCCESS,
  props<{ currentScope: ScopeVersion }>()
)
const submitConfigurationFail = createAction(
  ScopeConfigurationActionTypes.SUBMIT_CONFIGURATION_FAIL,
  props<{ error: Error }>()
)

const getModifiers = createAction(ScopeConfigurationActionTypes.GET_MODIFIERS, props<{ scenarioId: number }>())
const getModifiersSuccess = createAction(
  ScopeConfigurationActionTypes.GET_MODIFIERS_SUCCESS,
  props<{ modifiers: ComponentModifier[] }>()
)
const getModifiersFail = createAction(ScopeConfigurationActionTypes.GET_MODIFIERS_FAIL, props<{ error: Error }>())

export const ScopeConfigurationActions = {
  submitForm,
  showInvalidModifiersModal,

  updateConfiguration,

  saveConfiguration,
  saveConfigurationSuccess,
  saveConfigurationFail,

  submitConfiguration,
  submitConfigurationSuccess,
  submitConfigurationFail,

  getModifiers,
  getModifiersSuccess,
  getModifiersFail,
}
